var r=function(r){var a=-1,n=Array(r.size);return r.forEach((function(r){n[++a]=r})),n};export{r as default};
//# sourceMappingURL=_setToArray.js.map
